import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { LanguageService } from '@definitiv-packages/angular-dba-library';

import { ProjectLanguage } from '../../../../../roofsafetymanagement-library/src/public-api';

@Component({
  selector: 'app-start-view',
  templateUrl: './start-view.component.html',
  styleUrls: ['./start-view.component.scss'],
  standalone: false
})
export class StartViewComponent implements OnInit {
  public language: ProjectLanguage = new ProjectLanguage();

  constructor(
    public languageService: LanguageService,
    public dialog: MatDialog
  ) { }

  public ngOnInit(): void {
    this.language = this.languageService.getLanguageAsSetter();
  }
}
